/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCtmsCategoryOptionRespVo } from './GetCtmsCategoryOptionRespVo';
import {
    GetCtmsCategoryOptionRespVoFromJSON,
    GetCtmsCategoryOptionRespVoFromJSONTyped,
    GetCtmsCategoryOptionRespVoToJSON,
    GetCtmsCategoryOptionRespVoToJSONTyped,
} from './GetCtmsCategoryOptionRespVo';

/**
 * 
 * @export
 * @interface ResponseListGetCtmsCategoryOptionRespVo
 */
export interface ResponseListGetCtmsCategoryOptionRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListGetCtmsCategoryOptionRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListGetCtmsCategoryOptionRespVo
     */
    message?: string;
    /**
     * 
     * @type {Array<GetCtmsCategoryOptionRespVo>}
     * @memberof ResponseListGetCtmsCategoryOptionRespVo
     */
    data?: Array<GetCtmsCategoryOptionRespVo>;
}

/**
 * Check if a given object implements the ResponseListGetCtmsCategoryOptionRespVo interface.
 */
export function instanceOfResponseListGetCtmsCategoryOptionRespVo(value: object): value is ResponseListGetCtmsCategoryOptionRespVo {
    return true;
}

export function ResponseListGetCtmsCategoryOptionRespVoFromJSON(json: any): ResponseListGetCtmsCategoryOptionRespVo {
    return ResponseListGetCtmsCategoryOptionRespVoFromJSONTyped(json, false);
}

export function ResponseListGetCtmsCategoryOptionRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListGetCtmsCategoryOptionRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(GetCtmsCategoryOptionRespVoFromJSON)),
    };
}

export function ResponseListGetCtmsCategoryOptionRespVoToJSON(json: any): ResponseListGetCtmsCategoryOptionRespVo {
    return ResponseListGetCtmsCategoryOptionRespVoToJSONTyped(json, false);
}

export function ResponseListGetCtmsCategoryOptionRespVoToJSONTyped(value?: ResponseListGetCtmsCategoryOptionRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(GetCtmsCategoryOptionRespVoToJSON)),
    };
}

